import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-nota-fiscal-detail-dialog',
    templateUrl: './nota-fiscal-detail-dialog.component.html',
    styleUrls: ['./nota-fiscal-detail-dialog.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotaFiscalDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotaFiscalDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nota: any }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  // Helper method to get all keys from the nota object
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // Helper method to format display names of properties
  formatPropertyName(key: string): string {
    // Replace camelCase with spaces and capitalize first letter
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  }

  // Helper method to check if a value is an object or array
  isComplexValue(value: any): boolean {
    return (
      value !== null && typeof value === 'object' && !(value instanceof Date)
    );
  }

  // Helper method to determine if value is a Date
  isDate(value: any): boolean {
    return (
      value instanceof Date ||
      (typeof value === 'string' &&
        !isNaN(Date.parse(value)) &&
        value.includes('-'))
    );
  }

  // Helper method to format data based on type
  formatValue(key: string, value: any): string {
    if (value === null || value === undefined) return 'N/A';

    // Format currency values
    if (
      key.toLowerCase().includes('valor') ||
      key.toLowerCase().includes('preco')
    ) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    }

    // Format dates
    if (this.isDate(value)) {
      return new Date(value).toLocaleDateString('pt-BR');
    }

    return value.toString();
  }
}
